import styled from 'styled-components';

import { SectionTitle } from '../../../../../components/v2/Section';
import { StyledTextField } from '../../../../../components/Inputs';
import colors from '../../../../../styles/colors';

const SectionLabel = styled(SectionTitle)`
  color: ${colors.shades.gamma7};
  letter-spacing: 0.5px;
  margin-bottom: 12px;
`;

const TitleTextField = styled(StyledTextField)`
  & .MuiInputBase-input {
    font-weight: 600;
  }
`;

const FeatureRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px;
  border: 1px solid ${colors.shades.gamma3};
  border-radius: 6px;
  margin-bottom: 8px;
  background-color: ${colors.base.alpha};
`;

const DragHandle = styled.div`
  cursor: grab;
  color: ${colors.shades.gamma8};
  padding-top: 8px;
  flex-shrink: 0;

  &:active {
    cursor: grabbing;
  }
`;

const FeatureInputs = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export {
  SectionLabel,
  TitleTextField,
  FeatureRow,
  DragHandle,
  FeatureInputs,
};
